import axios from "axios";

export const STUDENT_URL = "/Student";
export const HOMEWORK_URL = "/Homework";

/** Mevcut Okulun Belli Bir Ödev Listesini Elde Eder */
export function getHomeworks(queryParams) {
  return axios.post(`${HOMEWORK_URL}/GetHomeworks`, queryParams);
}

/** Mevcut Okulun Belli Bir Ödev Listesini Sayfalama Olmadan Elde Eder */
export function getAllHomeworks(queryParams) {
  return axios.post(`${HOMEWORK_URL}/GetAllHomeworks`, queryParams);
}

/** Mevcut Okulun Belli Bir Ödev Raporunu Elde Eder */
export function getHomeworkReport(queryParams) {
  return axios.post(`${HOMEWORK_URL}/GetHomeworkReport`, queryParams);
}

/** Mevcut Okulun Belli Bir Ödev Raporunu Sayfalama Olmadan Elde Eder */
export function getAllHomeworkReport(queryParams) {
  return axios.post(`${HOMEWORK_URL}/GetAllHomeworkReport`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Sınıf, Öğretmen ve Ders Listesini Elde Eder */
export function getAllList() {
  return axios.get(`${HOMEWORK_URL}/GetList`);
}

/** Mevcut Okulun Belli Bir Dönemdeki Öğretmen ve Ders Listesini Elde Eder */
export function getList(term) {
  return axios.get(`${HOMEWORK_URL}/GetList/${term}`);
}

/** Mevcut Okula Ait Bir Dönemde Belli Bir Sınıftaki Öğrenci Listesini Elde Eder */
export function getStudents(term, sectionId) {
  return axios.get(`${STUDENT_URL}/GetStudentsInSection/${term}/${sectionId}`);
}

/** Belli Bir Ödev Gönderilen Belli Bir Öğrenci Listesini Elde Eder */
export function getHomeworkReceipents(queryParams) {
  return axios.post(`${HOMEWORK_URL}/GetHomeworkReceipents`, queryParams);
}

/** Belli Bir Ödev Gönderilen Belli Bir Öğrenci Listesini Sayfalama Olmadan Elde Eder */
export function getAllHomeworkReceipents(queryParams) {
  return axios.post(`${HOMEWORK_URL}/GetAllHomeworkReceipents`, queryParams);
}

/** Belli Bir Ödevin Detaylarını Elde Eder */
export function getHomeworkDetail(id) {
  return axios.get(`${HOMEWORK_URL}/GetHomeworkDetail/${id}`);
}

/** Belli Bir Ödevin Ekini İndirir */
export function downloadAttachment(id) {
  return axios.get(`${HOMEWORK_URL}/DownloadAttachment/${id}`, { responseType: "blob" });
}